export default {
  globalStyles: {
    container: {
      backgroundColor: "none",
      padding: 0,
    },
    promptLabel: {
      width: "9rem",
      paddingTop: "0px",
    },
    input: {
      fontSize: "1.125rem",
      lineHeight: "1.75rem",
      height: "100%",
      border: 0,
      margin: 0,
      padding: 0,
      // color: "#db0e15"
    },
    message: {
      fontSize: "1.125rem",
      lineHeight: "1.75rem",
    },
    content: {
      fontSize: "1.125rem",
      lineHeight: "1.75rem",
      padding: "20px 20px 20px 0",
    },
    inputText: {
      color: "white",
      fontSize: "1.125rem",
    },
  },
};
